module.exports = __webpack_public_path__ + "static/simple-pie-cac87482848fb3787cd832ae71430d78.png";